// removed by extract-text-webpack-plugin
module.exports = {"root":"WorkArea__root___2IoSc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateEditor/WorkArea/WorkArea.scss
// module id = 1040
// module chunks = 0